module.exports = {
  SETTLEMENT_STATUS: {
    READY: 'READY',
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    AWAITING_AT_SP: 'AWAITING_AT_SP',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    RETURNED: 'RETURNED',
    CANCELLED: 'CANCELLED'
  },
  SETTLEMENT_PARENT_STATUS: {
    READY: 'READY',
    COMPLETED: 'COMPLETED',
    SOURCE_SETTLEMENT_COMPLETED: 'SOURCE_SETTLEMENT_COMPLETED',
    SOURCE_SETTLEMENT_FAILED: 'SOURCE_SETTLEMENT_FAILED',
    DESTINATION_SETTLEMENT_FAILED: 'DESTINATION_SETTLEMENT_FAILED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    RETURNED: 'RETURNED',
    CANCELLED: 'CANCELLED'
  },
  SETTLEMENT_PARENT_TYPE: {
    ACCOUNT_TRANSFER: 'ACCOUNT_TRANSFER',
    CONTACT_PAYMENT: 'CONTACT_PAYMENT'
  },
  SETTLEMENT_TYPE: {
    SOURCE: 'SOURCE',
    DESTINATION: 'DESTINATION',
    SOURCE_RETURN: 'SOURCE_RETURN'
  },
  SETTLEMEMNT_STATUS_NOTE: {
    INSUFFICIENT_BALANCE: 'Insufficient Balance'
  },
  SETTLEMENT_PROCESS: {
    STP: 'STP',
    MANUAL: 'MANUAL',
    BATCH: 'BATCH'
  },
  UPDATE_SETTLEMENT_METHOD: {
    CRON: 'CRON',
    WEBHOOK: 'WEBHOOK'
  },
  SETTLEMENT_STAGE: {
    PICKED_FOR_SOURCE_SETTLEMENT: 'PICKED_FOR_SOURCE_SETTLEMENT',
    PICKED_FOR_DESTINATION_SETTLEMENT: 'PICKED_FOR_DESTINATION_SETTLEMENT'
  }
};
